export { default } from "./NewQuestionView";
